import React from 'react';

/** Content-shaped loading placeholder: a title bar plus shimmering rows.
 *  Replaces bare "Loading..." text states (see design audit F22). */
export function LoadingSkeleton({ rows = 6, title = true }: { rows?: number; title?: boolean }) {
  return (
    <div className="skeleton" role="status" aria-label="Loading">
      {title && <div className="skeleton__bar skeleton__bar--title" />}
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton__bar" style={{ width: `${92 - (i % 3) * 12}%` }} />
      ))}
    </div>
  );
}
